import React from 'react';
import { Link } from 'react-router-dom';
var MinesweeperPage = function () {
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            padding: '20px',
            boxSizing: 'border-box'
        } },
        React.createElement("div", null,
            React.createElement(Link, { to: "/", style: { textDecoration: 'none', color: '#2196F3' } }, "\u2190 Back to Home"),
            React.createElement("h1", null, "Minesweeper")),
        React.createElement("iframe", { src: "/games/minesweeper/index.html", style: {
                width: '100%',
                flex: 1,
                border: 'none'
            }, title: "Minesweeper Game" })));
};
export default MinesweeperPage;
